export const SEASONAL_EFFECTS = {
  sakura: { months: [3, 4, 5], label: '桜' },
  waves: { months: [6, 7, 8], label: '波' },
  autumn: { months: [9, 10, 11], label: '紅葉' },
  snow: { months: [12, 1, 2], label: '雪' },
};

const SEASONAL_EFFECT_KEYS = Object.keys(SEASONAL_EFFECTS);

export function getSeasonalEffectOverride() {
  if (typeof window === 'undefined') return null;
  const season = new URLSearchParams(window.location.search).get('season');
  return SEASONAL_EFFECT_KEYS.includes(season) ? season : null;
}

export function getSeasonalEffectType(date = new Date()) {
  const override = getSeasonalEffectOverride();
  if (override) return override;

  const month = date.getMonth() + 1;

  if (month >= 3 && month <= 5) return 'sakura';
  if (month >= 6 && month <= 8) return 'waves';
  if (month >= 9 && month <= 11) return 'autumn';
  return 'snow';
}